"use client";

import { motion } from "framer-motion";

const badgeGifs = [
  "/media/windows-cat.jpg",
  "/media/hatsunemiku.gif",
  "/media/code.jpg",
  "/media/cat.jpg",
  "/media/romania.png",
  "/media/idk.gif",
  "/media/ubuntu.jpg",
  "/media/money.gif",
  "/media/cracra.gif",
  "/media/earth.gif",
  "/media/ban.gif",
  "/media/python.gif",
  "/media/leon.gif",
  "/media/discord.jpg",
  "/media/ghost.jpg",
  "/media/archlinux.png",
  "/media/jane.gif",
  "/media/cs2.png",
  "/media/attack.gif",
  "/media/ragebait.gif",
  "/media/dyno.gif",
  "/media/europe.gif",
  "/media/cat2.gif",
];


const marqueeItems = [...badgeGifs, ...badgeGifs, ...badgeGifs.slice(0, 3)];

export function Badges() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
      className="mx-auto w-full max-w-sm space-y-3"
    >
      <div className="mb-2 text-center text-sm font-display italic text-muted-foreground/70 tracking-widest">
        mentions
      </div>
      <div className="overflow-hidden">
        <motion.div
          className="flex w-max gap-4"
          animate={{ x: ["0%", "-50%"] }}
          transition={{ duration: 20, ease: "linear", repeat: Infinity }}
        >
          {marqueeItems.map((gif, index) => (
            <div
              key={`${gif}-${index}`}
              className="flex h-10 w-24 shrink-0 overflow-hidden rounded-[0.4rem] bg-white/10"
            >
              <img src={gif} alt={`badge-${index + 1}`} className="h-full w-full object-cover" loading="lazy" />
            </div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
}
